<template>
  <div :class="[
          //`screen-${numberSize.split('%')[0]}`,
          //'half-screen',
          'docInteract', 'history-action'
        ]"
  >
    <vue-resizable
      style="left: 0 !important; min-width: 300px; max-width: 75vw; height: 100%;"
      :active="['l']"
    >
      <div
        class="flex-col"
        style="width: 100% !important; height: calc( 100vh - 56px );"
      >
        <div class="panel-header flex-row  flex__between has-border__bottom">
          <p class="title font-weight__bold">Lịch sử</p>
          <div class="btn__action">
            <!-- <i class="fal fa-expand item clickable" v-show="expandable"></i> -->
            <!-- <el-select
              class="none__border select__size"
              placeholder="chọn size"
              size="small"
              v-model="numberSize"
            >
              <el-option
                v-for="item in listSize"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select> -->
            <i
              v-show="closable"
              class="fal fa-times item clickable"
              @click="$emit('closeHistory')"
            ></i>
          </div>
        </div>

        <VuePerfectScrollbar
          class="scroll-history"
          :settings="perfectScrollbarSetting"
        >
          <div :class="['panel-body', 'list__action']">
            <slot name="histories"></slot>
          </div>
        </VuePerfectScrollbar>

        <div id="detail-footer" class="panel-footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </vue-resizable>
    <img class="icon__resize" src="../../../assets/img/ellipsis-vertical-solid.svg" alt="icon-resize">
  </div>
</template>

<script>
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import VueResizable from 'vue-resizable'

export default {
  name: "history-template",
  mixins: [handleRequestErrorMixin],
  props: ["expandable", "closable"],
  components: {
    VuePerfectScrollbar,
    VueResizable,
  },
  filters: {},

  data() {
    return {
      isFullScreen: true,
      histories: [],

      // numberSize: "30%",
      // listSize: ["30%", "50%", "70%", "100%"]
    };
  },

  watch: {},
  computed: {},

  created() {
  },

  methods: {}
};
</script>

<style scoped>
.full-screen {
  animation: half-to-full 0.5s;
  transition: 0.5s;
  width: 100%;
}

.half-screen {
  width: 75%;
  max-width: 420px;
  transition: 0.5s;
}


.screen-30{
  animation: half-to-full 0.5s;
  transition: 0.5s;
  width: 50% !important;
}

.screen-50{
  animation: half-to-full 0.5s;
  transition: 0.5s;
  width: 70% !important;
}

.screen-70{
  animation: half-to-full 0.5s;
  transition: 0.5s;
  width: 100% !important;
}

.screen-100{
  animation: half-to-full 0.5s;
  transition: 0.5s;
  width: 130% !important;
}

.btn__action{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  max-width: 50%;
}
.select__size{
  max-width: 60%;
  margin-right: 8px;
}

@keyframes half-to-full {
  from {
    width: 75%;
  }
  to {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/adminstration/ketluan/history-template.vue